import * as React from "react";

function SvgIcAddCircle(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 12a6 6 0 11-12 0 6 6 0 0112 0zm2 0a8 8 0 11-16 0 8 8 0 0116 0zm-7-3a1 1 0 10-2 0v2H9a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V9z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIcAddCircle;
